import { instance } from 'src/apis/index';

export interface IAnnouncementBody {
  announcement: string;
  announcementEnabled: boolean;
}

export const apiAnnouncement = {
  postAnnouncement: (parkingId: number, data: IAnnouncementBody) =>
    instance.post(`/parking/announcement?parkingId=${parkingId}`, data),
};
